// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import './index.css';

import Amplify from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { LangContextProvider } from './contexts/LanguageContext'

import App from './App';
import configureStore from './redux/configureStore';
import * as serviceWorker from './serviceWorker';
import {
  COGNITO_REGION,
  COGNITO_USER_POOL_ID,
  COGNITO_USER_POOL_WEB_CLIENT_ID,
  COGNITO_DOMAIN
} from './configuration';

const store = configureStore();

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: COGNITO_REGION,
    userPoolId: COGNITO_USER_POOL_ID,
    userPoolWebClientId: COGNITO_USER_POOL_WEB_CLIENT_ID
  },
  oauth: {
    domain: COGNITO_DOMAIN,
    redirectSignIn: `${window.location.origin}/home`,
    redirectSignOut: `${window.location.origin}/login`,
    responseType: 'token'
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LangContextProvider>
        <App />
      </LangContextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
